import { useCallback } from "react";
import { PrivatePageHeader } from "views/components/headers";
import { ButtonPrivateHeader } from "views/components/controles/buttons";
import { VoltarIcon } from "views/components/icons";
import { useHistory } from "react-router-dom";

export interface CriacaoHeaderProps {
  openPesquisa: boolean;
  setOpenPesquisa: (state: boolean) => any;
}

export const PropagandaCriacaoHeader = ({
  openPesquisa,
  setOpenPesquisa,
}: CriacaoHeaderProps) => {

  const { push } = useHistory();

  const voltarTela = useCallback(() => {
    push(`/propaganda`)
  }, [push])

  const leftArea = useCallback(
    () => (
      <ButtonPrivateHeader
        icon={<VoltarIcon tipo="PRIVATE_HEADER" />}
        tooltip="Voltar"
        onClick={voltarTela}
      />
    ),
    [voltarTela]
  );

  return (
    <>
      <PrivatePageHeader
        title="Criar Propaganda"
        leftArea={leftArea()}
      />
    </>
  );
};
